import React, { useState, useEffect } from 'react';
import './Navbar.css';

function Navbar({ onSearch, setCategory }) {
  const [show, handleShow] = useState(false);

  useEffect(() => {
    const scrollListener = () => {
      if (window.scrollY > 100) handleShow(true);
      else handleShow(false);
    };
    window.addEventListener("scroll", scrollListener);
    return () => window.removeEventListener("scroll", scrollListener);
  }, []);

  return (
    <nav className={`nav ${show && "nav__black"}`}>
      <div className="nav__contents">
        <h1 className="nav__logo" onClick={() => { setCategory("inicio"); window.scrollTo(0,0); }}>
          MOVIEMOOD
        </h1>
        
        <div className="nav__links">
          <span onClick={() => { setCategory("inicio"); window.scrollTo(0,0); }}>Início</span>
          <span onClick={() => { setCategory("series"); window.scrollTo(0,0); }}>Séries</span>
          <span onClick={() => { setCategory("filmes"); window.scrollTo(0,0); }}>Filmes</span>
        </div>

        <div className="nav__right">
          <input 
            onChange={(e) => onSearch(e.target.value)}
            className="nav__search" 
            type="text" 
            placeholder="Títulos, gêneros..." 
          />
          <img 
            className="nav__avatar" 
            src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png" 
            alt="Perfil" 
          />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
